<div class="header">
  <div class="title">Filters</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="filterForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Related To</mat-label>
      <mat-select [formControlName]="'objectTypeIn'" multiple>
        <mat-option *ngFor="let objectType of objectTypes" [value]="objectType">
          {{ objectType }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Assigned To</mat-label>
      <mat-select [formControlName]="'assignedUserIdIn'" multiple>
        <mat-option *ngFor="let user of users" [value]="user.id">
          {{ user.full_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <!-- Send -->
      <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="save()">
        <span>Run</span>
      </button>
    </div>
  </div>
</form>
